import moment from "moment";
import { GetServerSidePropsContext } from "next";
import nookies, { parseCookies, setCookie, destroyCookie } from "nookies";
import { wallet_provider_key } from "../config";
import { endpointOrigin } from "./apiConfig";

export const postRefreshTokenManagement = (
  refreshToken: string,
  urlOrigin?: string,
  ctx?: GetServerSidePropsContext
) => {
  const pathUrl = `${
    urlOrigin && process.env.NEXT_PUBLIC_STATE !== "development"
      ? `${urlOrigin}${endpointOrigin}`
      : endpointOrigin
  }/token`;

  let urlencoded = new URLSearchParams();
  urlencoded.append("grant_type", "refresh_token");
  urlencoded.append("refresh_token", refreshToken);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: urlencoded,
  };
  return fetch(pathUrl, options)
    .then((response) =>
      response.status === 200 ? response.json() : { code: response.status }
    )
    .then((result) => {
      if (result.status !== 200) {
        if (ctx) {
          nookies.destroy(
            ctx,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            {
              path: "/",
            }
          );
          nookies.destroy(
            ctx,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            {
              path: "/",
            }
          );
          nookies.destroy(ctx, wallet_provider_key, {
            path: "/",
          });
        } else {
          destroyCookie(null, process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any, {
            path: "/",
          });
          destroyCookie(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            {
              path: "/",
            }
          );
          nookies.destroy(null, wallet_provider_key, {
            path: "/",
          });
        }
      }
      return result;
    })
    .catch((_error: TypeError) => {
      return { code: 500 };
    });
};

// interface IOptions {
//   limit?: any;
//   offset?: any;
//   read?: any;
// }

export const getNotifications = (options?: any, accessToken?: string) => {
  const allCookie = parseCookies();
  const token = accessToken
    ? accessToken
    : allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  return fetch(
    `${endpointOrigin}/notifications?sort=createdAt:desc${
      options
        ? Object.keys(options)
            .map((op) => `&${op}=${options[op]}`)
            .join("")
        : ""
    }`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((response) => {
      return response.status === 401
        ? { code: response.status }
        : response.json();
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          setCookie(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            rsRefreshToken.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
          setCookie(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            rsRefreshToken.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );

          return fetch(
            `${endpointOrigin}/notifications?sort=createdAt:desc${
              options
                ? Object.keys(options)
                    .map((op) => `&${op}=${options[op]}`)
                    .join("")
                : ""
            }`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${rsRefreshToken.accessToken}`,
              },
            }
          )
            .then((response) => {
              return response.status === 401
                ? { code: response.status }
                : response.json();
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          return { code: 401 };
        }
      } else {
        return { ...result, accessToken: token };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const getNotificationId = (id: string, accessToken?: string) => {
  const allCookie = parseCookies();
  const token = accessToken
    ? accessToken
    : allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  return fetch(`${endpointOrigin}/notifications/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.status === 401
        ? { code: response.status }
        : response.json();
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
          // null
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          setCookie(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            rsRefreshToken.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
          setCookie(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            rsRefreshToken.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );

          return fetch(`${endpointOrigin}/notifications/${id}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
          })
            .then((response) => {
              return response.status === 401
                ? { code: response.status }
                : response.json();
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          return { code: 401 };
        }
      } else {
        return { ...result, accessToken: token };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

interface bodyInput {
  topic: string;
  level: string;
  read: boolean;
  detail: any;
}

export const updateNotifications = (
  nid: string,
  bodyInput: bodyInput,
  accessToken?: string
) => {
  const allCookie = parseCookies();
  const token = accessToken
    ? accessToken
    : allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  return fetch(`${endpointOrigin}/notifications/${nid}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(bodyInput),
  })
    .then((response) => {
      return response.status === 401
        ? { code: response.status }
        : response.json();
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
          // null
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            rsRefreshToken.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            rsRefreshToken.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );

          return fetch(`${endpointOrigin}/notifications/${nid}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
            body: JSON.stringify(bodyInput),
          })
            .then((response) => {
              return response.status === 401
                ? { code: response.status }
                : response.json();
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          destroyCookie(null, process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any, {
            path: "/",
          });
          destroyCookie(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            { path: "/" }
          );
          return { code: 401 };
        }
      } else {
        return { ...result, accessToken: token };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const updateNotificationsRead = (
  nid: string,
  bodyInput: any,
  accessToken?: string
) => {
  const allCookie = parseCookies();
  const token = accessToken
    ? accessToken
    : allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  return fetch(`${endpointOrigin}/notifications/${nid}/read`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(bodyInput),
  })
    .then((response) => {
      return response.status === 401
        ? { code: response.status }
        : response.json();
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
          // null
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            rsRefreshToken.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            rsRefreshToken.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );

          return fetch(`${endpointOrigin}/notifications/${nid}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
            body: JSON.stringify(bodyInput),
          })
            .then((response) => {
              return response.status === 401
                ? { code: response.status }
                : response.json();
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            {
              path: "/",
            }
          );
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            { path: "/" }
          );
          nookies.destroy(null, wallet_provider_key, {
            path: "/",
          });
          return { code: 401 };
        }
      } else {
        return { ...result, accessToken: token };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const deleteNotifications = (nid: string, accessToken?: string) => {
  const allCookie = parseCookies();
  const token = accessToken
    ? accessToken
    : allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  return fetch(`${endpointOrigin}/notifications/${nid}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return { code: response.status };
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
          // null
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            rsRefreshToken.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            rsRefreshToken.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );

          return fetch(`${endpointOrigin}/notifications/${nid}`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
          })
            .then((response) => {
              return { code: response.status };
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            {
              path: "/",
            }
          );
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            { path: "/" }
          );
          nookies.destroy(null, wallet_provider_key, {
            path: "/",
          });
          return { code: 401 };
        }
      } else {
        return { ...result, accessToken: token };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const deleteNotificationsMulti = (nids: any[], accessToken?: string) => {
  const allCookie = parseCookies();
  const token = accessToken
    ? accessToken
    : allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  return fetch(`${endpointOrigin}/notifications`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      notificationIds: nids,
    }),
  })
    .then((response) => {
      return { code: response.status };
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
          // null
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            rsRefreshToken.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            rsRefreshToken.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );

          return fetch(`${endpointOrigin}/notifications`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
            body: JSON.stringify({
              notificationIds: nids,
            }),
          })
            .then((response) => {
              return { code: response.status };
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            {
              path: "/",
            }
          );
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            { path: "/" }
          );
          nookies.destroy(null, wallet_provider_key, {
            path: "/",
          });
          return { code: 401 };
        }
      } else {
        return { ...result, accessToken: token };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const deleteNotificationAll = (accessToken?: string) => {
  const allCookie = parseCookies();
  const token = accessToken
    ? accessToken
    : allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  return fetch(`${endpointOrigin}/notifications/all`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return { code: response.status };
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
          // null
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            rsRefreshToken.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );
          nookies.set(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            rsRefreshToken.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );

          return fetch(`${endpointOrigin}/notifications`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
          })
            .then((response) => {
              return { code: response.status };
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            {
              path: "/",
            }
          );
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            { path: "/" }
          );
          nookies.destroy(null, wallet_provider_key, {
            path: "/",
          });
          return { code: 401 };
        }
      } else {
        return { ...result, accessToken: token };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};
